module.exports = __webpack_public_path__ + "img/media-4.58739eca.png";